import { connect } from "react-redux";
import PmSiteApprovals from "./ApprovalList";
import { bindActionCreators } from "redux";
import {getPmSiteState, updatePmSiteState} from "../../../services/redux/brandActivtion/sitesListing/action";

const mapStateToProps = (state) => ({
    sitePmStateList: state.baSiteListingReducer.sitePmStateList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getPmSiteState,
            updatePmSiteState
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PmSiteApprovals);
